<ion-content id="content-chat-modal">
    <div #scrollContainer id="chat-inner-container" [ngClass]="{'scrollbar-auto': globalService.isFirefox, 'scrollbar-thin': !globalService.isFirefox, 'cover': messageArray().length === 0}">
        <div #messagesList lines="none" id="messages-container" [ngClass]="{'add-padding': globalService.isFirefox}">
            @if (initChat() !== null) {
                <div class="message-container init-msg" [ngClass]="{'hide': hideInitMsg()}">
                    <div class="message-infos">
                        <h3>
                            IACDP
                        </h3>
                        <p class="date">
                            @if (initChat().date.includes('/')) {
                                <span>{{ initChat().date }}</span><br>
                                <span>{{ initChat().time }}</span>
                            }
                            @else {
                                @if (initChat().date){<span>{{ initChat().date | date:'dd/MM/YYYY' }}</span>} <br>
                                @if (initChat().date){<span>{{ initChat().date | date:'HH:mm':'+' }}</span>}
                            }
                        </p>                  
                    </div>
                    <div class="message">
                        <p [innerHTML]="initChat().text"></p>
                    </div>
                </div>
            }
            @if (messageArray().length > 0 ) {
                @for (message of messageArray(); track message.id) {
                    <div class="message-container" [ngClass]="{'user-message': message.sender !== 'IA'}">
                        <div class="message-infos">
                            @if(message.sender === "IA"){
                                <h3>
                                    IACDP
                                </h3>
                                <p class="date">
                                    @if (message.date.includes('/')) {
                                        <span>{{ message.date }}</span><br>
                                        <span>{{ message.time }}</span>
                                    }
                                    @else {
                                        @if (message.date){<span>{{ message.date | date:'dd/MM/YYYY' }}</span>} <br>
                                        @if (message.date){<span>{{ message.date | date:'HH:mm':'+' }}</span>}
                                    }
                                </p>
                            }                        
                        </div>
                        <div class="message">
                            <p [innerHTML]="message.text"></p>
                        </div>
                    </div>
                }
                @if (isThinking()) {
                    <div class="message-container">
                        <h3>IACDP</h3>
                        <div class="message">
                            <div id="spinner-container">
                                <ion-spinner name="dots"></ion-spinner>
                            </div>                    
                        </div>
                    </div>
                }
            }
        </div>
    </div>
        
    <div id="input-container">
        <ion-textarea id="content" type="text" [formControl]="userPrompt" rows="1" [autoGrow]="true" placeholder="Entrez votre message." (keypress)="sendMsgEnter($event)"></ion-textarea>
        <ion-button (click)="sendMessage()">
            <ion-icon name="chevron-up"></ion-icon>
        </ion-button>
    </div>
</ion-content>